import CaasService from '../caas.service.js';
import { getNewsroomNextPageV3, getEventTopics, handleNewsroomV3 } from "../caas.service.v3.js";
const { createStore } = Vuex;

export default config =>
	createStore({
		state: {
			displayShow: true,
			isLoading: false,
			displayEventFilter: false,
			count: 0,
			thema: config.thema,
			data: [],
			frontendpath: config.frontendpath,
			cdnpath: config.cdnpath,
			lngtxt: {},
			lngtxt_de: {
				"filterablelist": {
					"more_txt":"Mehr laden",
					"all_txt":"Alle",
					"result_txt":"Ergebnis",
					"results_txt":"Ergebnisse",
					"resultsfilter_txt":"zur getroffenen Filterauswahl"
				},
				"eventfilter": {
					"eventfiltertheme": {
						"title":"Thema",
						"choose_txt":"Thema auswählen",
						"button_txt":"Anwenden",
						"dropdown_txt": "Filterbereich für Themenauswahl"
					},
					"eventfiltertime": {
						"title":"Zeitraum",
						"choose_txt":"Zeitraum auswählen",
						"button_txt":"Anwenden",
						"dropdown_txt": "Filterbereich für Zeitraumauswahl",
						"errordate_txt": "Bitte prüfen Sie ob ein korrektes Datum eingegeben wurde und ob das Startdatum vor dem Enddatum liegt."
					},
					"eventfilterlocation": {
						"title":"Standort",
						"choose_txt":"Standort auswählen",
						"button_txt":"Anwenden",
						"dropdown_txt": "Filterbereich für Standortauswahl"
					},
					"eventfilteractivezone": {
						"title":"Ihre Filterauswahl",
						"delete_txt":"Filter zurücksetzen"
					}
				}
			},
			lngtxt_en: {
				"filterablelist": {
					"more_txt":"more",
					"all_txt":"All",
					"result_txt":"Result",
					"results_txt":"Results",
					"resultsfilter_txt":"to the filter selection"
				},
				"eventfilter":{
					"eventfiltertheme": {
						"title":"Topic",
						"choose_txt":"Choose topic",
						"button_txt":"Execute",
						"dropdown_txt": "Filter area for topic selection"
					},
					"eventfiltertime": {
						"title":"Period",
						"choose_txt":"Choose period",
						"button_txt":"Execute",
						"dropdown_txt": "Filter area for period selection",
						"errordate_txt": "Please check if a correct date has been entered and if the start date is before the end date."
					},
					"eventfilterlocation": {
						"title":"Location",
						"choose_txt":"Choose location",
						"button_txt":"Execute",
						"dropdown_txt": "Filter area for location selection"
					},
					"eventfilteractivezone": {
						"title":"Your filter selection",
						"delete_txt":"Reset Filter"
					}
				}
			},
			eventfilter: '',
			eventfilteritems: {},
			eventfilteritems_de: {
				"themeitems":[
					{"id":"fl_1_all", "title":"Alle Themen", "classes":"", "value": "1_all", "checked": "checked", "stage":"All"},
					{"id":"fl_1_01", "title":"Geowissenschaften und Umwelt", "classes":"", "value": "1_01", "stage":"Forschung"},
					{"id":"fl_1_02", "title":"Geschichte", "classes":"", "value": "1_02", "stage":"Forschung"},
					{"id":"fl_1_03", "title":"Gesellschaft, Wirtschaft, Recht", "classes":"", "value": "1_03", "stage":"Forschung"},
					{"id":"fl_1_04", "title":"Kultur, Literatur, Kunst", "classes":"", "value": "1_04", "stage":"Forschung"},
					{"id":"fl_1_05", "title":"Life Sciences, Biologie, Chemie", "classes":"", "value": "1_05", "stage":"Forschung"},
					{"id":"fl_1_06", "title":"Mathematik, Informatik, Technik", "classes":"", "value": "1_06", "stage":"Forschung"},
					{"id":"fl_1_07", "title":"Medizin, Pharmazie", "classes":"", "value": "1_07", "stage":"Forschung"},
					{"id":"fl_1_08", "title":"Pädagogik, Psychologie", "classes":"", "value": "1_08", "stage":"Forschung"},
					{"id":"fl_1_09", "title":"Physik, Nanowissenschaft", "classes":"", "value": "1_09", "stage":"Forschung"},
					{"id":"fl_1_10", "title":"Religion und Philosophie", "classes":"", "value": "1_10", "stage":"Forschung"},
					{"id":"fl_1_14", "title":"Tiermedizin", "classes":"", "value": "1_14", "stage":"Forschung"},
					{"id":"fl_1_11", "title":"Uni und Campusleben", "classes":"", "value": "1_11", "stage":"Uni-Campus"},
					{"id":"fl_1_12", "title":"Studium und Studienwahl", "classes":"", "value": "1_12", "stage":"Uni-Campus"},
					{"id":"fl_1_13", "title":"Job und Beruf- Karriere", "classes":"", "value": "1_13", "stage":"Uni-Campus"}
				],
				"timeitems":{
						"buttons": [
							{"id":"fl_fb_2_1", "title":"Nächsten 7 Tage", "classes":"", "info":"7"},
							{"id":"fl_fb_2_2", "title":"Nächsten 30 Tage", "classes":"", "info":"30"}
						],
						"inputs": [
							{"id":"fl_2_1", "label":"Start", "datetype":"Start", "classes":"", "placeholder":"Datum", "value":""},
							{"id":"fl_2_2", "label":"Ende", "datetype":"Stop", "classes":"", "placeholder":"Datum", "value":""}
						]				},
				"locationitems":[
					{"id":"fl_3_all", "title":"Alle Standorte", "classes":"", "value": "3_all", "checked": "checked", "stage":"All"},
					{"id":"fl_3_01", "title":"Campus Geschwister-Scholl-Platz", "classes":"", "value": "3_01", "stage":"All"},
					{"id":"fl_3_02", "title":"Campus Großhadern/Martinsried", "classes":"", "value": "3_02", "stage":"All"},
					{"id":"fl_3_03", "title":"Campus Sendlinger Tor", "classes":"", "value": "3_03", "stage":"All"},
					{"id":"fl_3_04", "title":"Campus Oberschleißheim", "classes":"", "value": "3_04", "stage":"All"},
					{"id":"fl_3_05", "title":"Campus Garching", "classes":"", "value": "3_05", "stage":"All"}
				]
			},
			eventfilteritems_en: {
				"themeitems":[
					{"id":"fl_1_all", "title":"All topics", "classes":"", "value": "1_all", "checked": "checked", "stage":"All"},
					{"id":"fl_1_04", "title":"Cultural Studies, Literature, Art", "classes":"", "value": "1_04", "stage":"Forschung"},
					{"id":"fl_1_01", "title":"Earth and Environmental Sciences", "classes":"", "value": "1_01", "stage":"Forschung"},
					{"id":"fl_1_08", "title":"Education, Psychology", "classes":"", "value": "1_08", "stage":"Forschung"},
					{"id":"fl_1_02", "title":"History", "classes":"", "value": "1_02", "stage":"Forschung"},
					{"id":"fl_1_05", "title":"Life Sciences, Biology, Chemistry", "classes":"", "value": "1_05", "stage":"Forschung"},
					{"id":"fl_1_06", "title":"Mathematics, Informatics, Technology", "classes":"", "value": "1_06", "stage":"Forschung"},
					{"id":"fl_1_07", "title":"Medicine, Pharmaceutical Sciences", "classes":"", "value": "1_07", "stage":"Forschung"},
					{"id":"fl_1_10", "title":"Philosophy and the Study of Religion", "classes":"", "value": "1_10", "stage":"Forschung"},
					{"id":"fl_1_09", "title":"Physics, Nanosciences", "classes":"", "value": "1_09", "stage":"Forschung"},
					{"id":"fl_1_03", "title":"Sociology,  Economics, Law", "classes":"", "value": "1_03", "stage":"Forschung"},
					{"id":"fl_1_14", "title":"Veterinary Medicine", "classes":"", "value": "1_14", "stage":"Forschung"},
					{"id":"fl_1_11", "title":"University affairs and life on campus", "classes":"", "value": "1_11", "stage":"Uni-Campus"},
					{"id":"fl_1_12", "title":"Studying at LMU", "classes":"", "value": "1_12", "stage":"Uni-Campus"},
					{"id":"fl_1_13", "title":"Jobs and careers", "classes":"", "value": "1_13", "stage":"Uni-Campus"}
				],
				"timeitems":{
						"buttons": [
							{"id":"fl_fb_2_1", "title":"Next 7 days", "classes":"", "info":"7"},
							{"id":"fl_fb_2_2", "title":"Next 30 days", "classes":"", "info":"30"}
						],
						"inputs": [
							{"id":"fl_2_1", "label":"Start", "datetype":"Start", "classes":"", "placeholder":"Datum", "value":""},
							{"id":"fl_2_2", "label":"Stop", "datetype":"Stop", "classes":"", "placeholder":"Datum", "value":""}
						]				},
				"locationitems":[
					{"id":"fl_3_all", "title":"All locations", "classes":"", "value": "3_all", "checked": "checked", "stage":"All"},
					{"id":"fl_3_01", "title":"Campus Geschwister-Scholl-Platz", "classes":"", "value": "3_01", "stage":"All"},
					{"id":"fl_3_02", "title":"Campus Großhadern/Martinsried", "classes":"", "value": "3_02", "stage":"All"},
					{"id":"fl_3_03", "title":"Campus Sendlinger Tor", "classes":"", "value": "3_03", "stage":"All"},
					{"id":"fl_3_04", "title":"Campus Oberschleißheim", "classes":"", "value": "3_04", "stage":"All"},
					{"id":"fl_3_05", "title":"Campus Garching", "classes":"", "value": "3_05", "stage":"All"}
				]
			},
			pageCount: 0,
			pageSize: 25,
			totalPages: 0,
			lng: config.lng,
			translatedlng: config.translatedlng,
			format: config.format,
			stage: config.stage,
			nextPage: '',
			prevPage: '',
			/*filters: config.filters*/
			filters: [],
			filters_de: [
				{"label":"News", "value": "news"},
				{"label":"Veranstaltungen", "value": "events"},
				{"label":"Alle", "value": "all"}],
			filters_en: [
				{"label":"News", "value": "news"},
				{"label":"Events", "value": "events"},
				{"label":"All", "value": "all"}]
		},
		actions: {
			async getEventTopics({ state, commit }, model ) {
				const { version3 } = config;
				const { thema, lng, eventfilteritems_de, eventfilteritems_en } = state;
				if (version3 && thema === 'events'){
					const mappedTopics = await getEventTopics(config,
							lng.toLowerCase() === 'de' ? eventfilteritems_de : eventfilteritems_en, lng, 1, 100);
					commit('setMappedTopics', {lng, mappedTopics});
				}
			},
			async getNewsroomInitData({ state, commit }, model) {
				commit('setIsLoading', true);
				const { version3 } = config;
				const { pageSize, thema, stage, lng, translatedlng, format, prios, eventfilter, eventfilteritems_de, eventfilteritems_en } = state;

				const response = version3
				   ? await handleNewsroomV3(config, pageSize, thema, stage, lng, translatedlng, format, model.prios, model.eventfilter)
				   : await CaasService(config)
				   		   .getNewsroomData(pageSize,thema,stage,lng,translatedlng,format, model.prios, model.eventfilter);


				commit('setInit', { data: response.data, prios: model.prios, eventfilter: model.eventfilter });
			},
			async getNewsroomNextPage({ state, commit }) {
				commit('setIsLoading', true);
				const { version3 } = config;
				const { pageSize } = state;
				const response = version3
					? await getNewsroomNextPageV3(config, state.nextPage, pageSize)
					: await CaasService(config).getNewsroomNextPage(state.nextPage);
				commit('setPaged', { data: response.data });
			}
		},
		getters: {
			newsData(state) {
				return state.data;
			},
			pageSize(state) {
				return state.pageSize;
			},
			pageCount(state) {
				return state.pageCount;
			},
			totalPages(state) {
				return state.totalPages;
			},
			count(state) {
				return state.count;
			},
			thema(state) {
				return state.thema;
			},
			stage(state) {
				return state.stage;
			},
			filters(state) {
				if(state.lng && state.lng == "EN"){
					state.filters = state.filters_en;
				} else {
					state.filters = state.filters_de;
				}
				return state.filters;
			},
			eventfilteritems(state) {
				if(state.lng && state.lng == "EN"){
					state.eventfilteritems = state.eventfilteritems_en;
				} else {
					state.eventfilteritems = state.eventfilteritems_de;
				}
				return state.eventfilteritems;
			},
			eventfilter(state) {
				return state.eventfilter;
			},
			lngshort(state) {
				return state.lng;
			},
			lngtxt(state) {
				if(state.lng && state.lng == "EN"){
					state.lngtxt = state.lngtxt_en;
				} else {
					state.lngtxt = state.lngtxt_de;
				}
				return state.lngtxt;
			},
			frontendpath(state) {
				return state.frontendpath;
			}
		},
		mutations: {
			setInit(state, model) {
				state.isLoading = false;
				state.displayShow = false;
				state.count = model.data._size;
				state.pageCount = model.data._total_pages;
				state.prios = model.prios;
				state.eventfilter = model.eventfilter;
				if(state.thema == "events") {
					state.displayEventFilter = true;
				} else {
					state.displayEventFilter = false;
				}
				if (model.data._embedded) {
					state.data =  model.data._embedded["rh:doc"];
				}else {
					state.data = [];
				}

				state.totalPages = model.data._total_pages;

				// Guard for undefined or null _link object
				if (!model.data._links) {
					return;
				}

				state.nextPage = model.data._links.next === undefined ? '' : model.data._links.next.href;
				state.prevPage = model.data._links.previous !== undefined
									? model.data._links.previous.href
									: model.data._links.first.href;
			},
			setIsLoading(state, isLoading) {
				state.isLoading = isLoading;
			},
			setPaged(state, model) {
				state.data = state.data.concat(model.data._embedded["rh:doc"]);
				state.isLoading = false;

				state.nextPage =
					model.data._links.next !== undefined
						? model.data._links.next.href
						: model.data._links.last.href;
				state.prevPage =
					model.data._links.previous !== undefined
						? model.data._links.previous.href
						: model.data._links.first.href;
			},
			setMappedTopics(state, model) {
				const { mappedTopics, lng} = model;
				if (lng === 'DE') {
					state.eventfilteritems_de.themeitems = mappedTopics;
				} else {
					state.eventfilteritems_en.themeitems = mappedTopics;
				}
			}
		}
	});
